import React from "react";

interface ITrackerIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const TrackerIcon: React.FC<ITrackerIconProps> = ({ sizeX = 24, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M5.3125 4.98214C5.13005 4.98214 4.98214 5.13005 4.98214 5.3125V8.17559C4.98214 8.35805 5.13005 8.50595 5.3125 8.50595H8.50595V4.98214H5.3125ZM10.4881 4.98214V8.50595H14.0119V4.98214H10.4881ZM15.994 4.98214V8.50595H19.1875C19.37 8.50595 19.5179 8.35805 19.5179 8.17559V5.3125C19.5179 5.13005 19.37 4.98214 19.1875 4.98214H15.994ZM15.994 10.4881H19.1875C20.4647 10.4881 21.5 9.45275 21.5 8.17559V5.3125C21.5 4.03534 20.4647 3 19.1875 3H15.003H9.49702H5.3125C4.03534 3 3 4.03534 3 5.3125V8.17559C3 9.45275 4.03534 10.4881 5.3125 10.4881H8.50595V15.003V19.1875C8.50595 20.4647 9.54129 21.5 10.8185 21.5H13.6815C14.9587 21.5 15.994 20.4647 15.994 19.1875V15.003V10.4881ZM14.0119 10.4881H10.4881V14.0119H14.0119V10.4881ZM14.0119 15.994H10.4881V19.1875C10.4881 19.37 10.636 19.5179 10.8185 19.5179H13.6815C13.864 19.5179 14.0119 19.37 14.0119 19.1875V15.994Z"
                  fill="#D0BDF8"/>
        </svg>
    );
}
